module.exports = __webpack_public_path__ + "static/img/2.2b70d80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/2.png
// module id = Fwmk
// module chunks = 0